import * as types from "../types";

export const auctionInvListRequest = ({reqAuctionId, user_id}) => ({
    type: types.FETCH_AUCTION_INV_REQUEST,
    payload:{
        reqAuctionId,
        user_id
    }
})

export const auctionInvListSuccess = ({resauctionInvData}) => ({
    type: types.FETCH_AUCTION_INV_SUCCESS,
    payload:{
        resauctionInvData   
    }
})

export const auctionInvListFailure = ({error}) => ({
    type: types.FETCH_AUCTION_INV_FAILURE,
    payload: {
        error: error.message
    }
});

export const auctionInvListReset = () => ({
    type: types.FETCH_AUCTION_INV_RESET,
});
